import React, { useCallback } from 'react';
import closeIcon from '@frontend/jetlend-assets/icons/icon--close.svg';
import { ITabItem } from './common';
import BadgeIcon from '@ui/ui/BadgeIcon/BadgeIcon';
import styles from './tabManager.module.scss';
import Tooltip from '@ui/ui/TooltipIcon/Tooltip';
import IconButton from '@ui/ui/inputs/IconButton/IconButton';

export interface IProps extends ITabItem {
    /** Флаг выделенной вкладки */
    isSelected: boolean;
    /** Максимальная ширина таба */
    maxWidth: number;
    /** Класс таба */
    className: string;
    /** Класс правой иконки таба */
    rightIconClassName: string;
    /** Класс левой иконки таба */
    leftIconClassName: string;
}

/** Компонент одного элемента таба в TabManager */
export default function TabManagerItem({
    onClick,
    onDelete,
    id,
    className,
    leftIcon,
    rightIcon,
    hint,
    activeLeftIcon,
    activeRightIcon,
    deletable,
    title,
    badge,
    rightIconClassName,
    leftIconClassName,
    isSelected,
    maxWidth,
}: IProps) {

    const didItemDeleted = useCallback(() => {
        if (onDelete) {
            onDelete(id);
        }
    }, [id, onDelete]);

    return (
        <Tooltip title={hint} disableWrapper >
            <button
                key={id}
                type="button"
                className={className}
                onClick={onClick}
                data-tab-id={id}
                style={ maxWidth > 0 ? { width: maxWidth } : undefined}
            >
                <div className={styles['tab-item__container']}>
                    {leftIcon && !isSelected &&
                        <img className={leftIconClassName} src={leftIcon} alt="" />
                    }
                    {(leftIcon || activeLeftIcon) && isSelected &&
                        <img className={leftIconClassName} src={activeLeftIcon || leftIcon} alt="" />
                    }
                    {title}
                    {rightIcon && !isSelected &&
                        <img className={rightIconClassName} src={rightIcon} alt="" />
                    }
                    {(rightIcon || activeRightIcon) && isSelected  &&
                        <img className={rightIconClassName} src={activeRightIcon || rightIcon} alt="" />
                    }
                    {(badge ?? 0) > 0 && <BadgeIcon count={badge ?? 0} className={styles['tab-item__badge--title']} />}
                </div>
                {deletable && (
                    <div className={styles['delete-icon--container']}>
                        <IconButton
                            icon={closeIcon}
                            onClick={didItemDeleted}
                            size="small"
                            iconClassName={styles['delete-icon']}
                            hint="Удалить"
                        />
                    </div>
                )}
            </button>
        </Tooltip>
    );
}
